const popupTickListAll = document.querySelectorAll(".popupTickList");
const popupTickListShowAll = document.querySelectorAll(".popupTickList ._jsShow");
const popupTickListHideAll = document.querySelectorAll(".popupTickList ._jsHide");
const popupTickListInputsAll = document.querySelectorAll(".popupTickList input");
const popupTickListTabTrapAll = document.querySelectorAll(".popupTickList ._jsTabTrap");




// show list on button click

popupTickListShowAll.forEach(popupTickListShow => {

	popupTickListShow.addEventListener("click", function() {

		// hide any open lists

		hideAnyOpenLists();

		// open this list and set focus

		const thisList = this.closest(".popupTickList");
		const innerList = thisList.querySelector("ul");

		thisList.classList.add("open");

		// setting focus on input won't work for some reason, so using other

		innerList.setAttribute("tabindex", "-1");
		innerList.focus();

		// enable inputs

		const inputsAll = thisList.querySelectorAll("input");

		inputsAll.forEach(input => {
			input.disabled = false;
		});
	});
});




// function to hide all list. (only one allowed at a time).

function hideAnyOpenLists() {

	// hide each list

	popupTickListAll.forEach(popupTickList => {
		popupTickList.classList.remove("open");
	});

	// disable all inputs

	popupTickListInputsAll.forEach(popupTickListInput => {
		popupTickListInput.disabled = true;
	});
}




// hide list on hide-button click

popupTickListHideAll.forEach(popupTickListHide => {
	popupTickListHide.addEventListener("click", hideAnyOpenLists);
});




// hide list on click outside

document.addEventListener("click", clickedSomewhere => {

	// find open list (only one present / allowed at a time)

	const openList = document.querySelector(".popupTickList.open");

	if (openList) { // if it exists

		const inside = clickedSomewhere.composedPath().includes(openList);

		if (!inside) { // if not clicking inside open list
			hideAnyOpenLists();
		}
	}
});




// hide list when pressing esc

document.addEventListener("keydown", (e) => {
	if (e.key === "Escape") {
		hideAnyOpenLists();
	}
});




// tabtrap – on focus, move focus to local hide-button

popupTickListTabTrapAll.forEach(popupTickListTabTrap => {

	// find local hide-button

	const hideButton = popupTickListTabTrap.closest(".tickListWrapper").querySelector("._jsHide");

	// set focus on local hide-button

	popupTickListTabTrap.addEventListener("focus", function() {
		hideButton.focus();
	});
});




// control ticklist inputs

function controlTickListInputs() {

	popupTickListInputsAll.forEach(popupTickListInput => {

		// if input checked, add class to li

		if (popupTickListInput.checked) {
			popupTickListInput.closest("li").classList.add("selected");
		}
		else {
			popupTickListInput.closest("li").classList.remove("selected");
		}

		// count checked inputs

		const thisList = popupTickListInput.closest(".popupTickList");
		const checkedInputCount = thisList.querySelectorAll("input:checked").length;

		// if list contains checked inputs, add class

		if (checkedInputCount > 0) {
			thisList.classList.add("hasCheckedItems");
		}
		else {
			thisList.classList.remove("hasCheckedItems");
		}
	});
}

// invoke function on click

popupTickListInputsAll.forEach(popupTickListInput => {
	popupTickListInput.addEventListener("click", controlTickListInputs);
});

// invoke when entering page without load, such as using back-button

window.addEventListener("pageshow", controlTickListInputs);




// clear input-dependent classes on parent form reset

popupTickListAll.forEach(popupTickList => {

	// find closest form
	const resetButton = document.querySelector("#resetFiltersButton");

	// on form reset...
    resetButton.addEventListener("click", function () {

		const thisTickList = document.querySelector(".popupTickList");

		// remove hasCheckedItems class
        thisTickList.classList.remove("hasCheckedItems");

		// remove li.selected classes
        thisTickList.querySelectorAll("li").forEach(listItem => {
			listItem.classList.remove("selected");
		});

		const tickListGroup = thisTickList.querySelectorAll(".tickList");

		if (tickListGroup) {
			tickListGroup.forEach(tickList => {
				//deselect all checkboxes
                var checkboxes = tickList.querySelectorAll("input[type=checkbox]");
                if (checkboxes && checkboxes.length > 0)
                    checkboxes.forEach(checkbox => {
                        checkbox.checked = false;
					});

				//select first radiobox
                var radiobuttons = tickList.querySelectorAll("input[type=radio]");
				if (radiobuttons && radiobuttons.length > 0) {
                    radiobuttons.forEach(radio => {
                        radio.checked = false;
					});

                    radiobuttons[0].checked = true;
                }
            });
        }
    });
});


